import { type ExpandedState } from '@synqo/frontend-component-library';

/** The expanded state with the row of the given id opened if it was closed, and closed if it was open. */
export const toggledExpansion = (expanded: ExpandedState, id: string): ExpandedState => {
    const open = expanded === true ? {} : expanded;

    return { ...open, [id]: !open[id] };
};
